import React from 'react'
import { Grid, makeStyles, TextField } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  noBorderRight: {
    '& .MuiInput-root': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    }
  },
  noBorderLeft: {
    '& .MuiInput-root': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    }
  }
}))

const CombinedTextField = ({ overdueDaysFrom, overdueDaysTo, onChange, placeholder1, placeholder2 }) => {
  const classes = useStyles()

  return (
    <Grid container alignItems="center" spacing={0}>
      <Grid item xs={6}>
        <TextField
          fullWidth
          name="overdueDaysFrom"
          value={overdueDaysFrom}
          onChange={onChange}
          placeholder={placeholder1}
          className={classes.noBorderRight}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          name="overdueDaysTo"
          value={overdueDaysTo}
          onChange={onChange}
          placeholder={placeholder2}
          className={classes.noBorderLeft}
        />
      </Grid>
    </Grid>
  )
}

export default CombinedTextField
